import React from 'react';
import {
  Typography,
  Row as GridRow,
  Col,
  FeedProgressBar,
  FeedStepper,
  FeedTimeline,
  FeedAvatarFeed,
  FeedIconCheckCircle,
  FeedIconThumbsUp,
} from 'design-system';
import { LockIcon } from '../../../design-system/components/Icons';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

const FEED_STEPPER_STEPS = [
  { key: 's1', label: 'Basic information' },
  { key: 's2', label: 'Financial information' },
  { key: 's3', label: 'Financial information' },
];

const FEED_STEPPER_VERTICAL_STEPS = [
  { key: 'v1', label: 'Safe food handling briefing', description: 'Video briefing' },
  { key: 'v2', label: 'Temperature control procedure', description: 'Document' },
  { key: 'v3', label: 'Questionnaire', description: '5 questions' },
  { key: 'v4', label: 'Confirmation' },
];

const FEED_TIMELINE_ITEMS = [
  {
    key: 't1',
    icon: <FeedIconCheckCircle />,
    iconBackground: '#293ef8',
    lead: 'Advanced to phone screening by',
    highlight: 'Benthany Blake',
    timestamp: 'Sep 25',
  },
  {
    key: 't2',
    icon: <FeedIconThumbsUp />,
    iconBackground: '#0fc64c',
    lead: 'Advanced to phone screening by',
    highlight: 'Benthany Blake',
    timestamp: 'Sep 25',
  },
  {
    key: 't3',
    icon: <FeedIconCheckCircle />,
    iconBackground: '#ecab14',
    lead: 'Advanced to phone screening by',
    highlight: 'Benthany Blake',
    timestamp: 'Sep 25',
  },
];

const FEED_AVATAR_ITEMS = [
  {
    key: 'a1',
    avatar: (
      <span
        aria-hidden
        style={{
          display: 'block',
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: '#5b6cff',
        }}
      />
    ),
    title: 'User 1',
    meta: '1 week',
    description: 'Deployed workcation (e490d in master) to production',
  },
  {
    key: 'a2',
    avatar: (
      <span
        aria-hidden
        style={{
          display: 'block',
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: '#0e9b3d',
        }}
      />
    ),
    title: 'User 2',
    meta: '1 week',
    description: 'Deployed workcation (e490d in master) to production',
  },
  {
    key: 'a3',
    avatar: (
      <span
        aria-hidden
        style={{
          display: 'block',
          width: 26,
          height: 26,
          borderRadius: '50%',
          background: '#ecab14',
        }}
      />
    ),
    title: 'User 3',
    meta: '1 week',
    description: 'Deployed workcation (e490d in master) to production',
  },
];

export default function FeedShowcase() {
  return (
    <GridRow>
      <Col xs={12}>
        <div className="design-system-section">
          <Typography variant="h1" className="section-title mb-4">
            Feed
          </Typography>
          <Typography variant="body1" className="mb-2">
            Progress, section steppers, activity timeline, and avatar rows (Poppins sizes and hex values from Figma).
          </Typography>
          <Separator className="mb-5" />

          <div className="mb-5">
            <Typography variant="headingMedium" className="mb-2" style={{ fontWeight: 500, color: '#000' }}>
              Progress bar
            </Typography>
            <Typography variant="body2" className="mb-3" style={{ color: '#768ea7' }}>
              Linear bar with semantic fill variants (default width 210px).
            </Typography>
            <div style={{ background: '#fff', padding: 16 }}>
              <FeedProgressBar id="ds-feed-pb-none" value={78} variant="positive" />
            </div>
            <div
              style={{
                padding: '34px 25px',
                background: 'rgba(121, 166, 255, 0.1)',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 15,
                alignItems: 'flex-end',
              }}
            >
              <div style={{ background: '#fff', padding: '16px', width: '19%' }}>
                <FeedProgressBar id="ds-feed-pb-none-variant" value={59} variant="none" />
                <Typography
                  variant="caption"
                  className="mt-2 mb-0 "
                  style={{ color: '#192839', textAlign: 'center', display: 'block' }}
                >
                  State = none
                </Typography>
              </div>
              <div style={{ background: '#fff', padding: '16px', width: '19%' }}>
                <FeedProgressBar value={55} variant="positive" />
                <Typography
                  variant="caption"
                  className="mt-2 mb-0 "
                  style={{ color: '#192839', textAlign: 'center', display: 'block' }}
                >
                  State = positive
                </Typography>
              </div>
              <div style={{ background: '#fff', padding: '16px', width: '19%' }}>
                <FeedProgressBar value={55} variant="negative" />
                <Typography
                  variant="caption"
                  className="mt-2 mb-0 "
                  style={{ color: '#192839', textAlign: 'center', display: 'block' }}
                >
                  State = negative
                </Typography>
              </div>
              <div style={{ background: '#fff', padding: '16px', width: '19%' }}>
                <FeedProgressBar value={55} variant="notice" />
                <Typography
                  variant="caption"
                  className="mt-2 mb-0 "
                  style={{ color: '#192839', textAlign: 'center', display: 'block' }}
                >
                  State = notice
                </Typography>
              </div>
              <div style={{ background: '#fff', padding: '16px', width: '19%' }}>
                <FeedProgressBar value={55} variant="neutral" />
                <Typography
                  variant="caption"
                  className="mt-2 mb-0 "
                  style={{ color: '#192839', textAlign: 'center', display: 'block' }}
                >
                  State = neutral
                </Typography>
              </div>
            </div>
          </div>

          <div className="mb-5">
            <Typography variant="headingMedium" className="mb-2" style={{ fontWeight: 500, color: '#000' }}>
              Progress bar — sections
            </Typography>
            <Typography variant="body2" className="mb-3" style={{ color: '#768ea7' }}>
              Steppers with 27px nodes, 4px track, optional custom markers.
            </Typography>
            <div
              style={{
                padding: '34px 25px',
                background: 'rgba(121, 166, 255, 0.1)',
              }}
            >
              <div
                style={{
                  background: '#fff',
                  padding: 25,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 55,
                  maxWidth: 872,
                }}
              >
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <Typography
                    variant="caption"
                    className="mb-2 inline-block"
                    style={{ color: '#192839', display: 'inline-block' }}
                  >
                    State = sections (green)
                  </Typography>
                  <FeedStepper
                    steps={FEED_STEPPER_STEPS}
                    activeIndex={0}
                    tone="green"
                    trackFillPercent={(0.5 / 3) * 100}
                  />
                </div>
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <Typography
                    variant="caption"
                    className="mb-2 inline-block"
                    style={{ color: '#192839', display: 'inline-block' }}
                  >
                    State = sections (primary)
                  </Typography>
                  <FeedStepper
                    steps={FEED_STEPPER_STEPS}
                    activeIndex={0}
                    tone="primary"
                    trackFillPercent={(0.5 / 3) * 100}
                  />
                </div>
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <Typography
                    variant="caption"
                    className="mb-2 inline-block"
                    style={{ color: '#192839', display: 'inline-block' }}
                  >
                    State = sections (neutral)
                  </Typography>
                  <FeedStepper
                    steps={FEED_STEPPER_STEPS}
                    activeIndex={0}
                    tone="neutral"
                    trackFillPercent={(0.5 / 3) * 100}
                  />
                </div>
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <Typography
                    variant="caption"
                    className="mb-2 inline-block"
                    style={{ color: '#192839', display: 'inline-block' }}
                  >
                    Step 2 active (custom markers)
                  </Typography>
                  <FeedStepper
                    steps={[
                      {
                        key: 'x1',
                        label: 'Basic information',
                        marker: <FeedIconCheckCircle />,
                      },
                      { key: 'x2', label: 'Review', marker: '2' },
                      { key: 'x3', label: 'Done', marker: '3' },
                    ]}
                    activeIndex={1}
                    tone="primary"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mb-5">
            <Typography variant="headingMedium" className="mb-2" style={{ fontWeight: 500, color: '#000' }}>
              Progress bar — sections (vertical)
            </Typography>
            <Typography variant="body2" className="mb-3" style={{ color: '#768ea7' }}>
              Vertical stepper with label and optional description beside each node. Pass{' '}
              <code>orientation="vertical"</code>. Use <code>nodeVariant="filled"</code> (default) or{' '}
              <code>nodeVariant="outline"</code> for light-background badges (L&amp;D sidebar).
            </Typography>
            <div
              style={{
                padding: '34px 25px',
                background: 'rgba(121, 166, 255, 0.1)',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 24,
              }}
            >
              <div style={{ background: '#fff', padding: 25, maxWidth: 320, flex: '1 1 280px' }}>
                <Typography variant="caption" className="mb-2" style={{ color: '#192839', display: 'block' }}>
                  nodeVariant = filled
                </Typography>
                <FeedStepper
                  steps={FEED_STEPPER_VERTICAL_STEPS}
                  activeIndex={0}
                  tone="primary"
                  orientation="vertical"
                  nodeVariant="filled"
                />
              </div>
              <div style={{ background: '#fff', padding: 25, maxWidth: 320, flex: '1 1 280px' }}>
                <Typography variant="caption" className="mb-2" style={{ color: '#192839', display: 'block' }}>
                  nodeVariant = outline (L&amp;D)
                </Typography>
                <FeedStepper
                  steps={[
                    ...FEED_STEPPER_VERTICAL_STEPS.slice(0, 2),
                    {
                      key: 'v3',
                      label: 'Questionnaire',
                      description: '5 questions',
                      marker: <LockIcon size={14} aria-hidden />,
                    },
                    FEED_STEPPER_VERTICAL_STEPS[3],
                  ]}
                  activeIndex={0}
                  tone="primary"
                  orientation="vertical"
                  nodeVariant="outline"
                />
              </div>
            </div>
          </div>

          <div className="mb-5">
            <Typography variant="headingMedium" className="mb-2" style={{ fontWeight: 500, color: '#000' }}>
              Activity — action state
            </Typography>
            <Typography variant="body2" className="mb-3" style={{ color: '#768ea7' }}>
              Timeline rows with icon rail and vertical connectors.
            </Typography>
            <div style={{ padding: 25, background: '#fff', maxWidth: 602 }}>
              <FeedTimeline items={FEED_TIMELINE_ITEMS} />
            </div>
          </div>

          <div>
            <Typography variant="headingMedium" className="mb-2" style={{ fontWeight: 500, color: '#000' }}>
              Activity — with avatar
            </Typography>
            <Typography variant="body2" className="mb-3" style={{ color: '#768ea7' }}>
              List rows with 26px avatar and divider.
            </Typography>
            <div style={{ padding: 25, background: '#fff', maxWidth: 602 }}>
              <FeedAvatarFeed items={FEED_AVATAR_ITEMS} />
            </div>
          </div>
        </div>
      </Col>
    </GridRow>
  );
}
